// extracted by mini-css-extract-plugin
export var arrow = "ExpandCollapseButton-module--arrow--8b438";
export var expandCollapseButton = "ExpandCollapseButton-module--expandCollapseButton--8fe45";